/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

export const FETCH_DOMAIN_APPROVER_HEAD_UNIT_REQUEST =
  "FETCH_DOMAIN_APPROVER_HEAD_UNIT_REQUEST";
export const FETCH_DOMAIN_APPROVER_HEAD_UNIT_SUCCESS =
  "FETCH_DOMAIN_APPROVER_HEAD_UNIT_SUCCESS";
export const FETCH_DOMAIN_APPROVER_HEAD_UNIT_FAILURE =
  "FETCH_DOMAIN_APPROVER_HEAD_UNIT_FAILURE";
